
import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import {  Link } from "react-router-dom";
import actions from '../../redux/actions';
import Layout from '../../layouts/Layout'
const Component = (props) => {
  console.log(props);
  const [ lineId, setLineId] = useState(props.data && props.data.user?props.data.user.lineId:"");
  return  <Layout >
        <div style={{padding:'100px'}}>
        <Link to="/"> กลับ </Link>
        {
          props.user?
          <div> user : {props.user.lineId}</div>
          :null
        }
      </div>
    </Layout>
};

const PageRoute = (props) => {
  if(!props.user){
    return (<Layout>
          <div style={{textAlign: 'center',padding:100,fontWeight: 500,fontSize: 36 ,color:' #FFF'}}> Please use it via LINE.   <Link to="/"> กลับ </Link></div>
    </Layout>);
  }return (
    <Component {...props}/>
  )
}

const mapStateToProps = state => {
  return {
    ...state
  };
};



export default connect(mapStateToProps, actions)(PageRoute);
